import React from 'react';
import envConfig from '../../../config/env';

/**
 * 20210126 自動職缺零筆 也不顯示
 */
class CompanyJobs extends React.Component {

    constructor(props){
        super(props);
        this.state={};
    }

    componentDidMount(){
        const cid = this.props.match.params.cid;
		this.props.getPositionList(cid, this.props.themeNum);
		this.props.getPositionGrpList(cid, this.props.themeNum);
        this.props.getkind00(cid);
    }

    render(){
		const cid = this.props.match.params.cid;
		const { positionGrpData } = this.props.positionGrpReducer;
        const { positionData } = this.props.positionReducer;
        const { kind00Data } = this.props.kind00Reducer;
        //console.log(kind00Data)
		let imgURL = "url(../../../image/tp06/jobs_bg-1.jpg)";
		const endpoint = "#recruitment-company-point";
		let companyurl = `https://www.1111.com.tw/corp/${cid}/${endpoint}`;

		let isAutoPosition=0;//add 20201207
		let positionURL2 = "https://www.1111.com.tw/job/";
        let owlLists = [];
		const limitCount=envConfig.PositionCount;

		if(positionGrpData && positionGrpData.length > 0){
            positionGrpData.forEach( element  => {
            isAutoPosition=element.position_IsAuto;
            })     
		}
		if(isAutoPosition===0){
			Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").forEach((element, index) => {
				let positionURL = positionURL2+ element.eNo + "/";
                owlLists.push(
					<div key={index} className="lqd-column carousel-item col-md-4">
							<div className="pricing-table pricing-table-minimal border-athens-gray">
							<a href={positionURL} >
								<div className="pricing-table-header">
									<p className="pricing">
										<span>{element.position_name}</span>
									</p>
									<h6>{element.position_workCity}</h6>
									<h5>{element.position_dutyName}</h5>
								</div>
								<div className="pricing-table-body">
									<ul>
										<li>{element.position_salary}</li>
										<li>{element.position_experience}</li>
									</ul>
								</div></a>
								<div className="pricing-table-footer">
									<a href={positionURL} className="btn btn-sm round btn-bordered border-thin px-2 font-size-17 btn-default btn-light margin-bottom_25px">
										<span>
											<span className="btn-txt">有興趣</span>
										</span>
									</a>
								</div>
							</div>
					</div>
				)
			})
		}
		else if(isAutoPosition===1){
			Array.isArray(kind00Data) && kind00Data.forEach((element, index) => {
				let positionURL = positionURL2+ element.eNo + "/";
				if(index < limitCount){
					owlLists.push(
						<div key={index} className="lqd-column carousel-item col-md-4">
								<div className="pricing-table pricing-table-minimal border-athens-gray">
								 <a href={positionURL} >
									<div className="pricing-table-header">
										<p className="pricing">
											<span>{element.Position}</span>
										</p>
										<h6>{element.WorkCity}</h6>
										<h5>{element.DutyName}</h5>
									</div>
									<div className="pricing-table-body">
										<ul>
											<li>{element.Salary}</li>
											<li>{element.Experience}</li>
										</ul>
									</div></a>
									<div className="pricing-table-footer">
										<a href={positionURL} className="btn btn-sm round btn-bordered border-thin px-2 font-size-17 btn-default btn-light margin-bottom_25px">
											<span>
												<span className="btn-txt">有興趣</span>
											</span>
										</a>
									</div>
								</div>
						</div>
					)
				}
			})
		}
        
		return (
			// vc_row
			<section id="jobs" className=" pt-30 pb-30 bg-cover" data-parallax="true" data-parallax-options='{ "parallaxBG": true }'  
					 style={((isAutoPosition===0 && positionData.length <= 0) 
					 || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
					 ) ? {display: 'none'}:{backgroundImage: imgURL}  } >
				<style>
				{((isAutoPosition===0 && positionData.length <= 0) 
				|| (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
				) && `.job-display {display:none !important;}`}
				</style> 
					<div className="container text-center">

						<div className="row">

							<div className="lqd-column col-md-6 col-md-offset-3">

								<header className="fancy-title mb-20 text-center">
									<h2 className="tp06-title-font-size">熱門職缺</h2>
								</header>

							</div>

						</div>

						<div className="row">
							<div  className="carousel-container carousel-nav-left carousel-nav-md carousel-dots-style1">
								<div className="carousel-items row" data-lqd-flickity='{"cellAlign":"center","prevNextButtons":false,"pageDots":true,"groupCells":false,"wrapAround":true,"pauseAutoPlayOnHover":false}'>
									{owlLists}
									{/* {Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").map((element, index) => {
                                        let positionURL = "https://www.1111.com.tw/job/"+ element.eNo + "/";
                                                    
                                        return(

										<div key={index} className="lqd-column carousel-item col-md-4">

											<div className="pricing-table pricing-table-minimal border-athens-gray">
							
												<div className="pricing-table-header">
														
													<p className="pricing">
														<span>{element.position_name}</span>
													</p>
										
													<h6>{element.position_workCity}</h6>
													<h5>{element.position_dutyName}</h5>
														
												</div>
													
												<div className="pricing-table-body">
													<ul>
														<li>{element.position_salary}</li>
														<li>{element.position_experience}</li>
													</ul>
												</div>
													
												<div className="pricing-table-footer">
													
													<a href={positionURL} className="btn btn-sm round btn-bordered border-thin px-2 font-size-17 btn-default btn-light margin-bottom_25px">
														<span>
															<span className="btn-txt">有興趣</span>
														</span>
													</a>
														
												</div>
													
											</div>
					
										</div>
										)

									})} */}

								</div>
							</div>
						
						</div>
							
								<a href={companyurl} target='_blank' rel='noopener noreferrer' className="mt-40 btn btn-sm btn-solid round lh-15 px-2" data-localscroll="true" data-localscroll-options='{"scrollBelowSection":true}'>
									<span>
										<span className="btn-txt">更多職缺</span>
									</span>
								</a>
								
							
					</div>

				</section>

		)

	}
}

export default CompanyJobs;